import { Canvas } from "@react-three/fiber";
import { DebugProvider } from "./Resources/DebugProvider.tsx";
import { ModelProvider, useModels } from "./Resources/ModelProvider.tsx";
import { Suspense, useRef, useState } from "react";
import Loading from "./Loading.tsx";
import {
  Float,
  Html,
  OrbitControls,
  OrthographicCamera,
  PerspectiveCamera,
  Preload,
  PresentationControls,
  RoundedBox,
  View,
} from "@react-three/drei";
import WfcExperience from "./WfcExperience.tsx";
import EditorExperience from "./Editor/EditorExperience.tsx";
import PrototypeCardCarousel from "./Editor/PrototypeCard/PrototypeCardCarousel.tsx";

export default function App() {
  const [editorMode, setEditorMode] = useState(false);

  const appRef = useRef<any>(null);

  return (
    <div ref={appRef} className={"h-full"}>
      <View className={"absolute top-0 left-0 w-full h-full"}>
        <ModelProvider>
          <DebugProvider>
            <Suspense fallback={<Loading />}>
              <Preload all />
              {editorMode ? <EditorExperience /> : <WfcExperience />}
            </Suspense>
          </DebugProvider>
        </ModelProvider>
      </View>

      {/*// TODO : ModelProvider Called twice, not good*/}
      {editorMode ? (
        <ModelProvider>
          <PrototypeCardCarousel />
        </ModelProvider>
      ) : null}
      <Canvas
        className={"fixed top-0 bottom-0 left-0 right-0 overflow-hidden"}
        eventSource={appRef}
        shadows
        camera={{
          fov: 55,
          near: 0.1,
          far: 200,
          position: [10, 10, 10],
        }}
      >
        <View.Port />
      </Canvas>
      <button
        className={
          "fixed top-0 w-40 text-white font-bold bg-gray-300 p-2 rounded m-3 transition-transform hover:bg-gray-400 hover:scale-95 active:scale-90"
        }
        onClick={() => setEditorMode(!editorMode)}
      >
        {editorMode ? "WFC Mode" : "Editor Mode"}
      </button>
    </div>
  );
}
